
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EnableCoverageSteps',
  props: {
    dsn: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      chevronIconAnimateClass: ''
    }
  },
  computed: {
    cliCommand(): string {
      const base =
        './bin/deepsource report --analyzer test-coverage --key <key> --value-file <path-to-coverage-report>'
      return this.$config.onPrem ? `${base} --host https://${this.$config.domain}` : base
    },
    installationCommand(): string {
      return 'curl -fsSL https://cli.deepsource.com/install | BINDIR=./bin sh'
    }
  },
  methods: {
    isOpenHandler(open: boolean): void {
      this.chevronIconAnimateClass = open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
    }
  }
})
